module.exports = __webpack_public_path__ + "static/img/sen-otp.00be34c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/sen-otp.png
// module id = H47t
// module chunks = 1